/**
 * A registered group tablet keeps its secret here (given once by the API when the head of
 * housekeeping registers it). With it, the sign-in screen shows the group's names and a
 * PIN pad instead of the password form. Storage can be unavailable (private mode, cleared
 * site data): the tablet then simply behaves like any other browser.
 */
const KEY = 'pms.device';

export interface DeviceInfo {
  token: string;
  id: string;
  name: string;
  groupCode: string | null;
}

export function getDevice(): DeviceInfo | null {
  try {
    const raw = localStorage.getItem(KEY);
    const d = raw ? (JSON.parse(raw) as DeviceInfo) : null;
    return d?.token ? d : null;
  } catch {
    return null;
  }
}

export function saveDevice(d: DeviceInfo): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(d));
  } catch {
    // Without storage the tablet keeps using passwords.
  }
}

export function forgetDevice(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing stored
  }
}
